import { render } from "./PCInformacionLineaPunto.vue?vue&type=template&id=4fed5f24&scoped=true"
import script from "./PCInformacionLineaPunto.vue?vue&type=script&lang=js"
export * from "./PCInformacionLineaPunto.vue?vue&type=script&lang=js"

import "./PCInformacionLineaPunto.vue?vue&type=style&index=0&id=4fed5f24&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fed5f24"]])

export default __exports__